if (!customElements.get('scroll-to-top-button')) {
  class ScrollToTopButton extends HTMLElement {
    constructor() {
      super();

      // Get the main header section
      this.header = document.querySelector('#main-header'); // Adjust the selector to your actual header element

      // Toggle the 'reveal' class based on scroll position
      this.toggleReveal();

      window.addEventListener('scroll', () => {
        requestAnimationFrame(() => {
          this.toggleReveal();
        });
      }, {passive: true});

      // Handle click event
      this.addEventListener('click', () => {
        this.scrollToTop();
      });

      // Handle Enter key event
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          this.scrollToTop();
        }
      });
    }

    // Check if the page has scrolled past the header and toggle the 'reveal' class
    toggleReveal() {
      const headerHeight = this.header ? this.header.offsetHeight : 0;
      this.classList.toggle('reveal', window.scrollY > headerHeight);
    }

    // Generic scroll-to-top function
    scrollToTop() {
      window.scrollTo({top: 0, behavior: 'smooth'});

      // Set a timeout to wait for the scroll to finish before focusing
      setTimeout(() => {
        document.querySelector('.skip-to-content-link')?.focus()
      }, 700);
    }
  }

  customElements.define('scroll-to-top-button', ScrollToTopButton);
}
